import { Route } from '@angular/router';

export const ProductRoutes: Route[] = [
  {
    path: 'products',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/product/product.page'),
      },
      {
        path: 'create',
        loadComponent: () => import('../pages/product/product-form/product-form.page'),
      },
      {
        path: ':id',
        loadComponent: () => import('../pages/product/product-detail/product-detail.page'),
      },
      {
        path: ':id/edit',
        loadComponent: () => import('../pages/product/product-form/product-form.page'),
      },
    ],
  },
];
